module.exports = __webpack_public_path__ + "media/doitman.51471cab.wav";